module.exports = __webpack_public_path__ + "img/descend.eb558812.png";